module.exports = __webpack_public_path__ + "static/img/a18.d891dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a18.png
// module id = vyZH
// module chunks = 1